<template>
    <div
        class="d-flex align-center"
        style="gap:6px;height:6px;margin-top:8px"
    >
        <div
            v-for="i in segments"
            :key="i"
            :style="{
                flex: 1,
                height: '100%',
                borderRadius: '9999px',
                backgroundColor: i <= filled ? 'var(--color-primary)' : 'rgba(173, 172, 183, 0.3)',
            }"
        />
    </div>
</template>

<script>
export default {
    name: 'KpiScoreBars',
    props: {
        value: {
            type: Number,
            default: 80,
        },
        segments: {
            type: Number,
            default: 5,
        },
    },
    computed: {
        filled() {
            return Math.round((this.value / 100) * this.segments)
        },
    },
}
</script>
